/** Shared stats used on the homepage hero and the About page. */
export const SITE_STATS = [
  { k: "13+", v: "Years Hauling" },
  { k: "48", v: "States Served" },
  { k: "24/7", v: "Dispatch" },
] as const;

type Props = {
  /** `hero` matches the homepage hero strip; `section` is a full-width band for inner pages. */
  variant?: "hero" | "section";
};

export function StatsBar({ variant = "section" }: Props) {
  if (variant === "hero") {
    return (
      <div className="mt-10 grid max-w-md grid-cols-3 gap-6 border-t border-secondary-foreground/15 pt-6">
        {SITE_STATS.map((s) => (
          <div key={s.v}>
            <div className="font-display text-3xl text-accent">{s.k}</div>
            <div className="text-xs uppercase tracking-widest text-secondary-foreground/60">
              {s.v}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <section className="relative overflow-hidden bg-secondary py-16 text-secondary-foreground">
      <div className="diag-stripes absolute left-0 top-0 h-2 w-full" />
      <div className="mx-auto grid max-w-7xl grid-cols-3 gap-6 px-4 text-center lg:px-8">
        {SITE_STATS.map((s) => (
          <div key={s.v}>
            <div className="font-display text-4xl text-accent md:text-5xl lg:text-6xl">{s.k}</div>
            <div className="mt-2 text-xs uppercase tracking-widest text-secondary-foreground/60 md:text-sm">
              {s.v}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
